import React, { Component, createElement } from 'react';

type ImageProps = {
    src: string;
    alt: string;
    loading?: 'lazy' | 'eager';
} & React.ImgHTMLAttributes<HTMLImageElement>;

class Image extends Component<ImageProps> {
    render() {
        const { src, alt, ...props } = this.props;

        return createElement('img', { ...props, loading: 'lazy', src, alt });
    }
}

export default Image;
